import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import PropTypes from "prop-types";

const ProgressCircle = ({ value }) => {
  const percentage = Math.round(value * 100);
  return (
    <div className="flex items-center justify-center h-full w-full p-2">
      <CircularProgressbar value={value} maxValue={1} text={`${percentage}%`} />
    </div>
  );
};

ProgressCircle.propTypes = {
  value: PropTypes.number.isRequired,
};

export default ProgressCircle;
